import React from "react";
import { useSelector } from "react-redux";
import SuggestionBox from "../../../common/suggestionBox/SuggestionBox";
import InsuranceList from "../../../components/yourAssets/BOA/insurance";
import { visited } from "../../../redux/slices/features/assetsOnBoardingSlice";

const Insurance = ({ next, back, tabText }) => {
  const updates = useSelector((state) => state.auditTrail.updates);
  return (
    <>
      <InsuranceList next={next} back={back} updates={updates} />
      <SuggestionBox
        mainText={tabText}
        tabName="Insurance"
        setVisited={visited}
      />
    </>
  );
};

export default Insurance;
